import { Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class SerproKeys extends MainKeys {
    get place() {
        return Places.mcSerpro
    }
}

export default SerproKeys
